import AlertMui from "@material-ui/lab/Alert"
import Box from "@material-ui/core/Box"

const Alert = props => {
    const { severity, children, marginBottom = 0 } = props

    return (
        <Box width="100%" marginBottom={marginBottom}>
            <AlertMui severity={severity}>{children}</AlertMui>
        </Box>
    )
}

export default Alert
